import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactStatus } from '../types/contact';

@Component({
  selector: 'dk-contact-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contact-status.component.html',
  styleUrls: ['./contact-status.component.scss'],
})
export class ContactStatusComponent {
  @Input() value: ContactStatus;

  @Input() showText = true;
}
